import {
  saveDesignApplicationDraft,
  updateDesignApplicationDraft
} from "./designApplicationService"
import { createDesign, deleteDesign } from "./designService"
import {
  createApplicant,
  updateApplicant,
  deleteApplicant
} from "./applicantService"
import {
  createSignature,
  updateSignature,
  deleteSignature
} from "./signatureService"

const FIXED_LANGUAGES = {
  filingLanguage: "English",
  secondLanguage: "German"
}

export async function saveDesignDraft(params: {
  referenceNumber: string
  designDrafts: any[]
  existingDesignIds?: string[]
  applicants?: any[] | null
  signature?: any | null
  draftId?: string | null
  signatureId?: string | null
  onDraftSaved?: (id: string) => void
  onDesignsSaved?: (ids: string[]) => void
  onSignatureSaved?: (id: string | null) => void
}) {
  const {
    referenceNumber,
    designDrafts,
    existingDesignIds = [],
    applicants,
    signature,
    draftId,
    signatureId,
    onDraftSaved,
    onDesignsSaved,
    onSignatureSaved
  } = params

  let savedSignatureId = signatureId || null
  const savedApplicantIds: string[] = []
  const savedDesignIds: string[] = []

  if (applicants && Array.isArray(applicants)) {
    for (const applicant of applicants) {
      if (applicant._id && applicant.isDeleted) {
        await deleteApplicant(applicant._id)
        continue
      }

      if (applicant._id && !applicant.isDeleted) {
        const updated = await updateApplicant(applicant._id, applicant)
        savedApplicantIds.push(updated._id)
        continue
      }

      if (!applicant._id && !applicant.isDeleted) {
        const created = await createApplicant(applicant)
        savedApplicantIds.push(created._id)
        applicant._id = created._id
      }
    }
  }

  const hasSignature =
    signature &&
    signature.accepted &&
    signature.signerName &&
    signature.signerCapacity

  if (!hasSignature) {
    if (savedSignatureId) await deleteSignature(savedSignatureId)
    savedSignatureId = null
    onSignatureSaved?.(null)
  } else if (savedSignatureId) {
    const updated = await updateSignature(savedSignatureId, {
      signerName: signature.signerName,
      signerCapacity: signature.signerCapacity
    })
    savedSignatureId = updated._id
    onSignatureSaved?.(savedSignatureId)
  } else {
    const created = await createSignature({
      signerName: signature.signerName,
      signerCapacity: signature.signerCapacity
    })
    savedSignatureId = created._id
    onSignatureSaved?.(savedSignatureId)
  }

  if (existingDesignIds.length > 0) {
    await Promise.all(
      existingDesignIds.map(id =>
        deleteDesign(id).catch(error =>
          console.error("Design could not be deleted:", error)
        )
      )
    )
  }

  for (const draft of designDrafts) {
    const created = await createDesign({
      ...draft.payload,
      name: draft.name
    })
    savedDesignIds.push(created._id)
  }

  onDesignsSaved?.(savedDesignIds)

  const payload = {
    referenceNumber,
    languages: FIXED_LANGUAGES,
    designs: savedDesignIds,
    applicants: savedApplicantIds,
    signature: savedSignatureId,
    priorities: [],
    representative: {
      name: "DANTZ IP & LAW",
      street: "Kurfürstendamm 43D",
      postalCode: "10719",
      city: "Berlin",
      country: "Deutschland",
      countryShort: "DE"
    }
  }

  if (draftId) {
    await updateDesignApplicationDraft(draftId, payload)
    return draftId
  }

  const created = await saveDesignApplicationDraft(payload)
  onDraftSaved?.(created._id)
  return created._id
}
